import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { Store } from '@ngrx/store';
import { ToasterService } from 'angular2-toaster';
import * as _ from 'lodash';
import { DatePipe } from "@angular/common";

import { ReportService,Combo2Service,WorkOrderService } from '../../../services/index';

import * as fromRootStore from '../../../reducers';
import { FinyearService } from '../../../services/index';
import { SalesPlanService } from '../../../services/index';
import { PurchaseOrderService } from '../../../services/purchaseorder.service';

@Component({
    selector: 'WoReturnComponent',
    host: { '(window:keydown)': 'hotkeys($event)' },
    templateUrl: './woReturn.html',
    styleUrls : ['woReturn.scss']
})
export class WoReturnComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input('tabID') tabID: string;
    @Input('params') params: any;
    @Input() active = false;
    @Input() dataContext;
    @Output() tabUpdateEvent = new EventEmitter();

    returnWono:number;
    isLoadMask: Promise<any>;

    constructor(public store: Store<fromRootStore.State>,public datePipe: DatePipe, private salesplanservice: SalesPlanService, private finyearService: FinyearService,private combo2Service:Combo2Service, private reportService: ReportService,private woservice: WorkOrderService, private modalService: BsModalService, public toasterService: ToasterService, private poservice: PurchaseOrderService) {
    }
    
    ngOnInit(){

    }
    hotkeys(event) {
        if (this.active) {
        }
    }
    
    workOrderReturn(mode: string , row: any): void {
        let tabObj = {};
        let params = {
            returnWono :this.returnWono
        };
        let that = this;
        this.isLoadMask = this.woservice
            .workOrderReturn(params)
            .then(function (res: any) {
                row = res.data;
                tabObj = {
                    action: 'NewTab',
                    params: {
                     tabName: 'EDIT WORK ORDER',
                     title: 'EDIT WORK ORDER',
                     mode : mode,
                     tabParent:'PURCHASE',
                     data: row,
                     name:'EDIT WORK ORDER'
                    }
                };
                that.tabUpdateEvent.emit(tabObj);

            });
    }       
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/workorder/woReturn.ts